export const signingAlgos = [
  'SHA_256_WITH_RSA',
  'SHA_384_WITH_RSA',
  'SHA_256_WITH_ECDSA',
];
